import { Device, DeviceInfo, OS, UserDevice } from './types';

export const deviceInfo: DeviceInfo = {
  device: {
    MOBILE: 'Mobile',
    DESKTOP: 'Desktop'
  },
  os: {
    ANDROID: 'Android',
    IOS: 'iOS',
    OTHER_OS: 'otherOS'
  }
};

export const getUserDevice = (userAgent: string | undefined): UserDevice => {
  const detectDevice = (): Device => {
    if (
      userAgent &&
      /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      )
    ) {
      return deviceInfo.device.MOBILE;
    } else {
      return deviceInfo.device.DESKTOP;
    }
  };

  const detectMobileOS = (): OS => {
    if (userAgent && /Android/.test(userAgent)) {
      return deviceInfo.os.ANDROID;
    } else if (userAgent && /iOS|iPhone|iPad|iPod/.test(userAgent)) {
      return deviceInfo.os.IOS;
    } else {
      return deviceInfo.os.OTHER_OS;
    }
  };

  const userDevice: Device = detectDevice();
  const userOS: OS = detectMobileOS();

  const { device, os } = deviceInfo;

  const isiOS = userDevice === device.MOBILE && userOS === os.IOS;
  const isAndroid = userDevice === device.MOBILE && userOS === os.ANDROID;
  const isDesktop = userDevice === device.DESKTOP || userOS === os.OTHER_OS;

  return { userDevice, userOS, isiOS, isAndroid, isDesktop };
};
